var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Page",
    { attrs: { title: _vm.title } },
    [
      _c(
        "van-list",
        {
          attrs: {
            finished: _vm.finished,
            "immediate-check": false,
            "finished-text": "没有更多了"
          },
          on: { load: _vm.onLoad },
          model: {
            value: _vm.loading,
            callback: function($$v) {
              _vm.loading = $$v
            },
            expression: "loading"
          }
        },
        [
          _c(
            "div",
            { staticClass: "clientAssign" },
            [
              _c("div", { staticClass: "header-titile-all" }, [
                _c("div", { staticClass: "searchTitle-top-header flex" }, [
                  _c("div", { staticClass: "searchTitle-top" }, [
                    ""
                      ? _c(
                          "div",
                          {
                            staticClass: "picker-alls",
                            on: { click: _vm.pickerClient }
                          },
                          [
                            _vm._v(
                              "全部\n                                    "
                            ),
                            _c("div", { staticClass: "triangle_border_down" })
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "flex input-search-flex" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.inputValue,
                            expression: "inputValue"
                          }
                        ],
                        staticClass: "search_input",
                        attrs: { type: "text", placeholder: "客户姓名/手机" },
                        domProps: { value: _vm.inputValue },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.inputValue = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "search-img",
                        attrs: {
                          src: require("@/assets/img/search.png"),
                          alt: ""
                        }
                      })
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "filtrate-list flex",
                      on: { click: _vm.searchFilter }
                    },
                    [
                      _c("img", {
                        staticClass: "filtrate-img",
                        attrs: {
                          src: require("@/assets/img/filtrate.png"),
                          alt: ""
                        }
                      }),
                      _vm._v(" "),
                      _c("div", [_vm._v("筛选")])
                    ]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "flex filtrate-lists-area flexJ" },
                  [
                    _c("van-checkbox", {
                      attrs: { "checked-color": "#0076FF" },
                      on: {
                        click: function($event) {
                          return _vm.allCheckbox_(_vm.allCheckbox)
                        }
                      },
                      model: {
                        value: _vm.allCheckbox,
                        callback: function($$v) {
                          _vm.allCheckbox = $$v
                        },
                        expression: "allCheckbox"
                      }
                    }),
                    _vm._v(" "),
                    _vm._l(_vm.filtrateList, function(item, index) {
                      return _c(
                        "div",
                        {
                          key: index,
                          staticClass: "flex filtrate-lists-area-item"
                        },
                        [
                          _c("div", [_vm._v(_vm._s(item.name))]),
                          _vm._v(" "),
                          _c("div", { staticClass: "triangle" }, [
                            _c("div", { staticClass: "triangle_border_up" }),
                            _vm._v(" "),
                            _c("div", { staticClass: "triangle_border_down" })
                          ])
                        ]
                      )
                    })
                  ],
                  2
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "scroll-view" },
                [
                  _c(
                    "van-list",
                    {
                      attrs: {
                        finished: _vm.finished,
                        "finished-text": "没有更多了"
                      },
                      on: { load: _vm.onLoad },
                      model: {
                        value: _vm.loading,
                        callback: function($$v) {
                          _vm.loading = $$v
                        },
                        expression: "loading"
                      }
                    },
                    _vm._l(_vm.list, function(item, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "scroll-view-list-item" },
                        [
                          _c(
                            "div",
                            { staticClass: "select-lists" },
                            [
                              _c("van-checkbox", {
                                attrs: { "checked-color": "#0076FF" },
                                model: {
                                  value: item.edit,
                                  callback: function($$v) {
                                    _vm.$set(item, "edit", $$v)
                                  },
                                  expression: "item.edit"
                                }
                              }),
                              _vm._v(" "),
                              _c("div"),
                              _vm._v(" "),
                              _c("div", { staticClass: "information-list" }, [
                                _c(
                                  "div",
                                  { staticClass: "information-list-item" },
                                  [
                                    _vm._v(
                                      "客户姓名：" + _vm._s(item.custName || "")
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "information-list-item" },
                                  [
                                    _vm._v(
                                      "联系方式：" + _vm._s(item.mobile || "")
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "information-list-item" },
                                  [
                                    _vm._v(
                                      "预计购买日期: " +
                                        _vm._s(
                                          item.planDate
                                            ? item.planDate.split(" ")[0]
                                            : ""
                                        )
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "information-list-item" },
                                  [
                                    _vm._v(
                                      "最近购买日期: " +
                                        _vm._s(item.buyDate || "")
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "information-list-item" },
                                  [
                                    _vm._v(
                                      "最近跟进日期: " +
                                        _vm._s(item.followDate || "")
                                    )
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "operation" },
                                _vm._l(item.vipStar, function(item, index) {
                                  return _c("img", {
                                    key: index,
                                    staticClass: "vipStars",
                                    attrs: {
                                      src: require("@/assets/img/vipStar.png"),
                                      alt: ""
                                    }
                                  })
                                }),
                                0
                              )
                            ],
                            1
                          )
                        ]
                      )
                    }),
                    0
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "van-popup",
                {
                  attrs: { position: "bottom", overlay: true },
                  model: {
                    value: _vm.show,
                    callback: function($$v) {
                      _vm.show = $$v
                    },
                    expression: "show"
                  }
                },
                [
                  _c("van-picker", {
                    staticClass: "van-picker-li",
                    attrs: {
                      "show-toolbar": "",
                      title: "",
                      columns: _vm.columnsCode
                    },
                    on: { cancel: _vm.onCancelCode, confirm: _vm.onConfirmCode }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "toAssign" }, [
                _c(
                  "div",
                  {
                    staticClass: "toAssign-button",
                    on: { click: _vm.toAssign }
                  },
                  [_vm._v("分派")]
                )
              ])
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-743e7c68", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-743e7c68","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/client/stayClient.vue
// module id = null
// module chunks = 